import { HEX } from "../../../src/actions/hex-patterns";
import { Targeting } from "../../../src/actions/targeting";
import { SEC } from "../../../src/time-utils";
const frost_armor = {
  slug: "frost_armor",
  name: "Frost Armor",
  description: "Encases you in ice that slows attackers",
  abilityIcon: "frost_armor",
  costs: [
    { stat: "mana", value: 15 }
  ],
  targeting: Targeting.Self,
  cooldown: SEC(10),
  impactSchedule: {
    [0]: [
      {
        hexes: HEX.DOT,
        effect: {
          statChanges: [
            {
              stat: "health",
              direction: "loss",
              scalingFactors: {}
            }
          ],
          addConditions: [
            {
              slug: "frost_armor",
              name: "Frost Armor",
              tags: ["buff", "ice"]
            }
          ],
          removeConditionsByTag: []
        }
      }
    ]
  },
  tags: ["spell", "buff", "blue", "defensive"]
};
export {
  frost_armor
};
//# sourceMappingURL=data:application/json;base64,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
